import Slide from "./Slide.Container";

export default Slide;